export default __webpack_public_path__ + "static/media/pen.78b596f1.svg";